<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style="color: white;  text-align: center; margin-bottom: 10px">Volunteer Service</h2>
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <p style="color: white;">
          Proyash-Chattogram is a well-known organization dedicated to providing
          education and support to children with special needs and their
          families in Chattogram, Bangladesh. Volunteering with
          Proyash-Chattogram can be a rewarding experience where you can
          contribute to the development and well-being of these children.
        </p>
      </div>
    </div>
  </div>
</div>
